module.exports = __webpack_public_path__ + "static/media/icon_myreposit.9e189e7a.svg";